import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import { ctxTachograph } from '@/contexts/TachographCtx';
import { useContext } from 'react';

export function TachoGraphDateSelectMobile({ setSelectedDates }: { setSelectedDates: (from: Date, to: Date) => void }) {
  const tachographCtx = useContext(ctxTachograph);
  if (!tachographCtx) return;

  return (
    <div data-qa-element-id="mobile_data_selector_panel">
      <StaticDateRangeSelect setSelectedDates={setSelectedDates} />
    </div>
  );
}
